import { keyEventPropName } from './env';
import { MODIFIER } from './key-map';
import expect from '@src/slide/infrastructure/module/independent/assert/expect';

export function isModifier(e) {
    return !!Object.values(MODIFIER)
        .map(obj => obj[keyEventPropName])
        .find((item) => {
            if (expect(item).isArray()) {
                return item.includes(e[keyEventPropName]);
            }
            return item === e[keyEventPropName];
        });
}
